export default {
  title: {
    en: 'Quick Bet',
  },
}
